module.exports = __webpack_public_path__ + "img/shopping-bag-01.5b7a279b.svg";